import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef(({ children, className, flush = 'none', fullWidth = false, innerWidth = 'default', padding = false, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { ref: ref, className: className, flush: flush, padding: padding, ...otherProps }, fullWidth ? children : React.createElement(S.SiteWide, { width: innerWidth }, children)));
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
